import React, { Component } from 'react'
import SearchForm from '../../components/dashboardComponent/searchForm'
import Gauge from '../../components/dashboardComponent/gauge'
import { Container, Segment } from 'semantic-ui-react'
import QuicksightDashboard from './quicksightDashboard';
import IdleTimer from 'react-idle-timer'
import { isQuicksightReportEnabled } from '../../utils/constant';

export default class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
     
    };
    this.idleTimer = null
    this.handleOnAction = this.handleOnAction.bind(this)
    this.handleOnActive = this.handleOnActive.bind(this)
    this.handleOnIdle = this.handleOnIdle.bind(this)
  }

  componentWillUnmount() {

  }

  handleOnAction(event) {
    //console.log('user did something', event)
  }

  handleOnActive(event) {
    //console.log('user is active', event)
    //console.log('time remaining', this.idleTimer.getRemainingTime())
  }

  handleOnIdle(event) {
    //console.log('user is idle', event)
    //console.log('last active', this.idleTimer.getLastActiveTime())
    window.location.href = "/shipment"
  }

  render() {
    return (
      <React.Fragment>
        <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          timeout={1000 * 60 * 5}
          onActive={this.handleOnActive}
          onIdle={this.handleOnIdle}
          onAction={this.handleOnAction}
          debounce={250}
        />
        {localStorage.getItem('role') != "Vendor" ? (<div id="dashboard">
          <div className="p-2">
            { isQuicksightReportEnabled ?
              <>
                <QuicksightDashboard></QuicksightDashboard>
              </>
              :
              <><Segment>
                <Container fluid className="p-3">
                  <SearchForm />
                  <Gauge />
                </Container>
              </Segment></>
            }

          </div>
        </div>)
          :
          <></>
        }

      </React.Fragment>
    )
  }
}
